/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FindPrivateKeyResponseDto } from '../models/find-private-key-response-dto';
import { NewTenant } from '../models/new-tenant';
import { NewUserByTenantAdmin } from '../models/new-user-by-tenant-admin';
import { Tenant } from '../models/tenant';
import { TenantPartial } from '../models/tenant-partial';
import { TenantWithRelations } from '../models/tenant-with-relations';
import { User } from '../models/user';
import { UserWithRelations } from '../models/user-with-relations';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class TenantControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation tenantControllerCount
   */
  static readonly TenantControllerCountPath = '/tenants/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation tenantControllerFindPrivateKey
   */
  static readonly TenantControllerFindPrivateKeyPath = '/tenants/read/private-key';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPrivateKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrivateKey$Response(params?: {
  }): Observable<StrictHttpResponse<FindPrivateKeyResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerFindPrivateKeyPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FindPrivateKeyResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findPrivateKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrivateKey(params?: {
  }): Observable<FindPrivateKeyResponseDto> {

    return this.findPrivateKey$Response(params).pipe(
      map((r: StrictHttpResponse<FindPrivateKeyResponseDto>) => r.body as FindPrivateKeyResponseDto)
    );
  }

  /**
   * Path part for operation tenantControllerFindUsers
   */
  static readonly TenantControllerFindUsersPath = '/tenants/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  findUsers$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<UserWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerFindUsersPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UserWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findUsers(params?: {
    filter?: any;
  }): Observable<Array<UserWithRelations>> {

    return this.findUsers$Response(params).pipe(
      map((r: StrictHttpResponse<Array<UserWithRelations>>) => r.body as Array<UserWithRelations>)
    );
  }

  /**
   * Path part for operation tenantControllerCreateUser
   */
  static readonly TenantControllerCreateUserPath = '/tenants/users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser$Response(params?: {
    body?: NewUserByTenantAdmin
  }): Observable<StrictHttpResponse<User>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerCreateUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<User>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUser(params?: {
    body?: NewUserByTenantAdmin
  }): Observable<User> {

    return this.createUser$Response(params).pipe(
      map((r: StrictHttpResponse<User>) => r.body as User)
    );
  }

  /**
   * Path part for operation tenantControllerFindById
   */
  static readonly TenantControllerFindByIdPath = '/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<TenantWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TenantWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<TenantWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<TenantWithRelations>) => r.body as TenantWithRelations)
    );
  }

  /**
   * Path part for operation tenantControllerUpdateById
   */
  static readonly TenantControllerUpdateByIdPath = '/tenants/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: TenantPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: TenantPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation tenantControllerFind
   */
  static readonly TenantControllerFindPath = '/tenants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<TenantWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TenantWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<TenantWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TenantWithRelations>>) => r.body as Array<TenantWithRelations>)
    );
  }

  /**
   * Path part for operation tenantControllerCreate
   */
  static readonly TenantControllerCreatePath = '/tenants';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewTenant
  }): Observable<StrictHttpResponse<Tenant>> {

    const rb = new RequestBuilder(this.rootUrl, TenantControllerService.TenantControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Tenant>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewTenant
  }): Observable<Tenant> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<Tenant>) => r.body as Tenant)
    );
  }

}
